import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackPageView } from '@/lib/meta-pixel';
import { useTrackingParams } from '@/hooks/useTrackingParams';

/**
 * Initializes the Meta Pixel and fires PageView events on every
 * route change. Also captures UTM parameters and fbclid from URLs.
 *
 * Place this inside a <BrowserRouter> to get route-change tracking.
 * If VITE_META_PIXEL_ID is not set, all tracking is silently skipped.
 */
export function MetaPixelProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);

  // Capture UTM + fbclid params
  useTrackingParams();

  // Initialize Pixel once
  useEffect(() => {
    initMetaPixel();
  }, []);

  // Track PageView on route changes (skip duplicate fires for same path)
  useEffect(() => {
    if (location.pathname !== previousPath.current) {
      trackPageView();
      previousPath.current = location.pathname;
    }
  }, [location.pathname]);

  return <>{children}</>;
}
